export default __webpack_public_path__ + "static/rsz_1nasz-głos-poznanski-81c860584fedc289a682000e181bb392.jpg";